// import { ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import { createTheme, ThemeProvider, styled, responsiveFontSizes } from '@mui/material/styles'
const ThemeOptions = {
  palette: {
    type: 'light',
    primary: {
      main: '#677489',// '#436168',
      dark: '#162c3d',
      contrastText: '#d2dcdc',
      light: '#e3effe',
    },
    secondary: {
      main: '#597594',//'#E6E873',
      light: '#e7ebef',
      dark: '#2b4c71',
      contrastText: '#edd8d2',
    },
    call2action: {
      main: '#E6E873',
      light: '#ffff8d',
      dark: '#c3ab29',
      contrastText: '#000000',
    },
    error: {
      main: '#ED254E',
    },
    info: {
      main: '#D2DCDC',
    },
    text: {
      primary: '#284155',//'#436168',
      secondary: '#597594',
      light: '#d2dcdc'
    },
    background: {
      default: '#ffffff',
      gray: '#FDFBFE',
      highlight: '#edd8d2',
      dark: '#131731',
    },
    divider: '#528586',
    warning: {
      main: '#F9DC5C',
    },
  },
  typography: {
    h1: {
      fontFamily: 'Rubik, sans-serif',
      fontSize: '60pt',
      fontWeight: 800,
      lineHeight: 1.2
      // lineHeight: '120%'
    },
    fontFamily: 'Rubik, sans-serif',
    h2: {
      fontFamily: 'Rubik, sans-serif',
      fontSize: '44pt',
      fontWeight: 800,
      lineHeight: 1.2
      // lineHeight: '120%'
    },
    h3: {
      fontFamily: 'Rubik, sans-serif',
      fontSize: '32pt',
      fontWeight: 800,
      lineHeight: 1.2

      // lineHeight: '120%'
    },
    h4: {
      fontFamily: 'Rubik, sans-serif',
      fontSize: '20pt',
      fontWeight: 800,
      lineHeight: 1.2

      // lineHeight: '120%'
    },
    h5: {
      fontFamily: 'Rubik, sans-serif',
      fontSize: '20pt',
      lineHeight: 1.2

      // lineHeight: '120%'
    },
    fontSize: 16,
  },
  spacing: 6,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1440,
    },
  },
  drawerWidth: 250,
  questionnaireTitleWidth: 320,
  overrides: {
    MuiAppBar: {
      colorInherit: {
        backgroundColor: '#689f38',
        color: '#fff',
      },
    },
    MuiSwitch: {
      root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: 8,
      },
      switchBase: {
        padding: 1,
        '&$checked, &$colorPrimary$checked, &$colorSecondary$checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + $track': {
            opacity: 1,
            border: 'none',
          },
        },
      },
      thumb: {
        width: 24,
        height: 24,
      },
      track: {
        borderRadius: 13,
        border: '1px solid #bdbdbd',
        backgroundColor: '#fafafa',
        opacity: 1,
        transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
  },
  props: {
    MuiAppBar: {
      color: 'inherit',
    },
    MuiTooltip: {
      arrow: true,
    },
  },
}

const theme = responsiveFontSizes(createTheme(ThemeOptions))

const CustomTheme = props => <ThemeProvider theme={theme}>
    {props.children}
</ThemeProvider>

export default CustomTheme